import firebase from 'firebase';
import React, { FC, useState } from 'react';
import { Context } from './context';
import { Props } from './types';
import { getUserTokenFromLocalStorage } from './utils';

const UserProvider: FC<Props> = ({ user: defaultUser = null, children }) => {
  const [user, setUser] = useState<firebase.User | null>(
    defaultUser ?? getUserTokenFromLocalStorage(),
  );

  function handleSetUser(user: firebase.User | null) {
    setUser(user);
    window.localStorage.setItem('user', JSON.stringify(user));
  }

  return <Context.Provider value={{ user, setUser: handleSetUser }}>{children}</Context.Provider>;
};

export default UserProvider;
